import { formatNumber } from '@utils/number';

export type StatCardDeltaTone = 'positive' | 'negative' | 'neutral';

export function formatStatCardDelta(delta: number): string {
  const sign = delta > 0 ? '+' : delta < 0 ? '-' : '';
  return `${sign}${formatNumber(Math.abs(delta), 1)}%`;
}

export function getStatCardDeltaTone(delta: number | string): StatCardDeltaTone {
  if (typeof delta === 'number') {
    if (delta > 0) return 'positive';
    if (delta < 0) return 'negative';
    return 'neutral';
  }

  const trimmed = delta.trim();
  if (trimmed.startsWith('-')) return 'negative';
  if (trimmed.startsWith('+')) return 'positive';
  return 'neutral';
}
